(() => {
  if (window.__vhpRecipeCardVideoAutoplay) return;

  const parseThreshold = (el) => {
    const raw = el.getAttribute('data-card-video-autoplay-threshold');
    if (!raw) return 0.45;
    const n = Number(raw);
    return Number.isFinite(n) && n > 0 && n <= 1 ? n : 0.45;
  };

  const observersByThreshold = new Map();

  const getObserver = (threshold) => {
    let obs = observersByThreshold.get(threshold);
    if (obs) return obs;
    obs = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (!entry.isIntersecting) return;
          const el = entry.target;
          obs.unobserve(el);
          autoplayWhenVisible(el);
        });
      },
      { threshold }
    );
    observersByThreshold.set(threshold, obs);
    return obs;
  };

  const finishLoading = (el) => {
    el.classList.remove('is-loading');
    el.classList.add('is-ready');
  };

  const waitForPosterReady = (posterImg) => {
    if (!posterImg) return Promise.resolve();
    const loaded = posterImg.complete
      ? Promise.resolve()
      : new Promise((resolve) => {
          posterImg.addEventListener('load', resolve, { once: true });
          posterImg.addEventListener('error', resolve, { once: true });
        });
    return loaded.then(() =>
      posterImg.decode ? posterImg.decode().catch(() => {}) : undefined
    );
  };

  const autoplayWhenVisible = (el) => {
    if (!(el instanceof HTMLElement)) return;
    if (el.dataset.autoplayStarted === 'true') return;
    el.dataset.autoplayStarted = 'true';

    const posterImg = el.querySelector('.deferred-media__poster-image');

    const startPlayback = () => {
      const playButton = el.querySelector('[ref="deferredMediaPlayButton"], .deferred-media__poster-button');
      if (playButton) {
        playButton.click();
      } else {
        finishLoading(el);
        return;
      }

      const waitForMedia = () => {
        const media = el.querySelector('video, iframe');
        if (!media) {
          window.setTimeout(waitForMedia, 120);
          return;
        }

        if (media.tagName === 'VIDEO') {
          media.addEventListener('loadeddata', () => finishLoading(el), { once: true });
          media.addEventListener('canplay', () => finishLoading(el), { once: true });
          media.addEventListener('error', () => finishLoading(el), { once: true });
        } else {
          media.addEventListener('load', () => finishLoading(el), { once: true });
          media.addEventListener('error', () => finishLoading(el), { once: true });
          window.setTimeout(() => finishLoading(el), 3000);
        }
      };

      waitForMedia();
    };

    waitForPosterReady(posterImg).then(startPlayback);
  };

  const scan = () => {
    document.querySelectorAll('deferred-media[data-card-video-autoplay="true"]').forEach((el) => {
      if (!(el instanceof HTMLElement)) return;
      if (el.dataset.autoplayObserved === 'true') return;
      el.dataset.autoplayObserved = 'true';
      el.classList.add('is-loading');
      const threshold = parseThreshold(el);
      getObserver(threshold).observe(el);
    });
  };

  window.__vhpRecipeCardVideoAutoplay = { scan };
  window.vhpRecipeCardVideoAutoplayScan = scan;

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', scan, { once: true });
  } else {
    scan();
  }
})();
